import { NS_CONFIGURATION, PROJECT, EDITOR, BOARD } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';
import * as _currentBoard from './currentBoard/actions';


export const currentBoard = _currentBoard;

export const {
  INIT,
  SAVE,
  ADD,
  REMOVE,
  SET_NAME,
  INVALIDATE,
  RESET_CHANGES,
  CANCEL_SAVE
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, BOARD)({
    INIT: ASYNC,
    SAVE: ASYNC,
    ADD: ASYNC,
    REMOVE: ASYNC,
    INVALIDATE: ASYNC,
    RESET_CHANGES: ASYNC,
    CANCEL_SAVE: SYNC,
  });

export const init = {
  begin: ({ projectId, selectedIndex }) => action(INIT.BEGIN, { projectId, selectedIndex }),
  end: ({
    boards,
    systemBoard,
    boardOptions,
    groupedOptions,
    simpleOptions,
    containerOptions,
    itemOptions,
    statuses,
    items,
       }) => action(INIT.END, {
      boards,
      systemBoard,
      boardOptions,
      groupedOptions,
      simpleOptions,
      containerOptions,
      itemOptions,
      statuses,
      items,
    }),
};
export const save = {
  begin: () => action(SAVE.BEGIN),
  end: ({ changes, id }) => action(SAVE.END, { changes, id }),
};
export const add = {
  begin: () => action(ADD.BEGIN),
  end: ({
    boardOptions,
    }) => action(ADD.END, {
      boardOptions,
    }),
};
export const remove = {
  begin: localId => action(REMOVE.BEGIN, { localId }),
  end: ({
    boardOptions,
    }) => action(REMOVE.END, {
      boardOptions,
    }),
};
export const invalidate = {
  begin: () => action(INVALIDATE.BEGIN),
  end: ({ boardOptions, changes }) => action(INVALIDATE.END, { boardOptions, changes }),
};
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
          resetBoard,
          changes,
        }) => action(RESET_CHANGES.END, {
    resetBoard,
    changes
  }),
};
export const cancelSave = () => action(CANCEL_SAVE);



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/board/actions.js